var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalancingScooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 116,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.56 56.452l-4.9 40.107a10.713 10.713 0 012.9-.385c12.436 0 12.358 18.999.214 18.999-5.26 0-8.341-2.972-9.377-6.563l-4.884-.165-.99-8.296h4.394l4.753-49.103 4.26.04.715-4.313-13.357-.253.44 4.45 4.152.04-5.114 45.154-9.15-3.46 2.147-36.817s-8.814-7.584-7.33-14.198c1.305-5.814 3.094-14.995 3.094-14.995 6.868-6.85 23.323-5.73 30.265-.927 0 0 2.932 9.915 4.32 16.499 1.538 7.289-6.551 14.186-6.551 14.186zM36.597 8.548c0 12.77-15.421 11.647-16.775.85-1.408-11.222 16.775-13.456 16.775-.85zM9.562 96.175c12.435 0 12.357 18.999.213 18.999-13.298 0-12.696-19-.213-19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancingScooter);
export default __webpack_public_path__ + "static/media/balancing-scooter.be82759d2037a611c10c83fe5bec7b66.svg";
export { ForwardRef as ReactComponent };